
import { defineComponent, ref, onMounted, reactive } from 'vue';
import { common } from "@/common/services/Common";
import { config } from "@/Config";
export default defineComponent({
    name: 'ShowMemberListModal',
    props: {
        showModal: Boolean,
        members: { type: Array, required: true },
        projectRoleCodes: {
            type: Array,
            required: true,
            default: () => []
        },

    },
    setup(props, { emit }) {
        const showTooltip = ref<number | null>(null);
        const state = reactive({
            data: {
                imageBaseUrl: "",
                showMemberListModal: false,
            },
        });

        function formatDate(date: any) {
            if (!date) return 'N/A';
            const dateTimeString = common.localDateAndTime(date);
            return dateTimeString.split(',')[0];
        }

        function calculateValidTill(completedDate: any, validityDays: any) {
            const date = new Date(completedDate);
            if (isNaN(date.getTime()) || !validityDays) return 'N/A';
            date.setDate(date.getDate() + Number(validityDays));
            const fullDateTime = common.localDateAndTime(date.toISOString());
            return fullDateTime.split(',')[0];
        }

        function displayEmailOrPhone(email: string): string {
            if (!email) return '';

            const cleaned = email.replace(/\D/g, '');

            // Check if it's a valid US number with 11 digits starting with 1
            if (cleaned.length === 11 && cleaned.startsWith('1')) {
                const area = cleaned.slice(1, 4);
                const mid = cleaned.slice(4, 7);
                const last = cleaned.slice(7);
                return `+1 (${area}) ${mid}-${last}`;
            }

            // Not a valid phone number, return as-is
            return email;
        }

        function closeModal(data: any) {
            emit("close", data);
            state.data.showMemberListModal = !state.data.showMemberListModal;
            // $("#showMemberListModal").modal("hide");
        }

        onMounted(() => {
            if (props.showModal) {
                state.data.imageBaseUrl = config.imageBaseUrl;
                state.data.showMemberListModal = !state.data.showMemberListModal;
                // $("#showMemberListModal").modal("show")
            }
        });

        return {
            state,
            showTooltip,
            formatDate,
            calculateValidTill,
            displayEmailOrPhone,
            closeModal
        };
    }
});
